import { render } from "./InitiativeDetails.vue?vue&type=template&id=a5279e78"
import script from "./InitiativeDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./InitiativeDetails.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Results/InitiativeDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5279e78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5279e78', __exports__)) {
    api.reload('a5279e78', __exports__)
  }
  
  module.hot.accept("./InitiativeDetails.vue?vue&type=template&id=a5279e78", () => {
    api.rerender('a5279e78', render)
  })

}


export default __exports__